import styled, { css } from 'styled-components';

import { Text } from '../../../../components';
import { ANIM, COLORS, SPACE } from '../../../../theme/tokens';

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACE[16]};
`;

export const Tabs = styled.div`
  display: flex;
  gap: ${SPACE[8]};
`;

/** The upload target; `$over` while a file is dragged over it (a quiet border and wash, nothing more). */
export const DropZone = styled.label<{ $over: boolean; $busy: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${SPACE[8]};
  min-height: 180px;
  padding: ${SPACE[24]};
  border-radius: 12px;
  border: 1px dashed ${COLORS.featureCardBorder};
  background: ${COLORS.surfaceSoft};
  color: ${COLORS.textMuted};
  text-align: center;
  cursor: pointer;
  transition:
    border-color ${ANIM.INTERACT_MS}ms ease,
    background ${ANIM.INTERACT_MS}ms ease;

  ${(p) =>
    p.$over &&
    css`
      border-color: ${COLORS.accent};
      background: ${COLORS.surfaceFaint};
    `}
  ${(p) =>
    p.$busy &&
    css`
      cursor: progress;
    `}
`;

export const HiddenInput = styled.input`
  position: absolute;
  width: 1px;
  height: 1px;
  opacity: 0;
  pointer-events: none;
`;

export const DropTitle = styled(Text)`
  font-size: 14px;
  color: ${COLORS.text};
`;

export const DropHint = styled(Text)`
  font-size: 12px;
  color: ${COLORS.textMuted};
`;

export const ErrorText = styled(Text)`
  font-size: 13px;
  color: ${COLORS.danger};
`;

export const WarnText = styled(Text)`
  font-size: 13px;
  color: ${COLORS.warning};
`;

export const Note = styled(Text)`
  font-size: 12px;
  color: ${COLORS.textMuted};
`;

export const Grid = styled.ul`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
  gap: ${SPACE[12]};
  margin: 0;
  padding: 0;
  list-style: none;
`;

export const GridItem = styled.li`
  display: flex;
  min-width: 0;
`;

export const Thumb = styled.button<{ $selected: boolean }>`
  display: block;
  width: 100%;
  aspect-ratio: 1.91 / 1;
  padding: 0;
  border-radius: 8px;
  border: 1px solid ${(p) => (p.$selected ? COLORS.accent : COLORS.panelBorder)};
  background: ${COLORS.surfaceInset};
  overflow: hidden;
  cursor: pointer;
  transition: border-color ${ANIM.INTERACT_MS}ms ease;

  &:hover:not(:disabled) {
    border-color: ${COLORS.hoverBorderLit};
  }
  &:disabled {
    cursor: progress;
  }

  img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const Footer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: ${SPACE[8]};
  width: 100%;
`;
